import(/* webpackMode: "eager" */ "D:\\New folder (2)\\www\\www\\www\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "D:\\New folder (2)\\www\\www\\www\\node_modules\\next\\dist\\client\\link.js");
